
import Transformer from '@/transformers/transformer'
import { assetURL } from '@/utils'

export default class CreditNoteTransformer extends Transformer {
  static fetch({ id, receiver, sender, tax_receipt: taxReceipt, uuid,
    cfdi_type: cfdiType, xml_proof_payment: xmlProofPayment,
    pdf_proof_payment: pdfProofPayment, serie, folio, date, subtotal,
    total, exchange_rate: exchangeRate, way_to_pay: wayToPay, 
    add_date: addDate, is_active: isActive, currency }) {
    return {
      id, receiver, sender, taxReceipt, uuid, cfdiType,
      xmlProofPayment: assetURL(xmlProofPayment),
      pdfProofPayment: assetURL(pdfProofPayment),
      serie, folio, date, subtotal, total, exchangeRate,
      wayToPay, addDate, isActive, currency
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/taxReceipt/creditNote.js